module.exports = __webpack_public_path__ + "media/images/map-icons/open-osmde-f1d565295f080e18805ccb692ac3e92d.png";